export default {

  EVENT: {
    NEW_REF_OR_CUSTOMER_SUCCESS:"NEW_REF_OR_CUSTOMER_SUCCESS",
    NOTIFICATION: {
      INFO: "NOTIFY_INFO",
      WARN: "NOTIFY_WARN",
      ERROR: "NOTIFY_ERROR",
      BANNER_INFO: "NOTIFY_BANNER_INFO",
      BANNER_CONF: "NOTIFY_BANNER_CONF",
      BANNER_ERROR: "NOTIFY_BANNER_ERROR",
      DEFAULT: "NOTIFY_DEFAULT",
    },
    PRODUCT: {
      UPDATE_PRICES_INFO: "UPDATE_PRICES"
    },
    BARCODE: {
      UPDATE_OPTION_ADD_TO_CART: "UPDATE_OPTION_ADD_TO_CART",
      CAUSALITY: {
        'CC': {
          codeCausality: "CC",
          descriptionCausality: "Color Card",
          typeCausality: "CAMPIONE"
        },
        'CR': {
          codeCausality: "CR",
          descriptionCausality: "Fabrics Reference",
          typeCausality: "CAMPIONE"
        },
        'yarns': {
          codeCausality: "",
          descriptionCausality: "",
          typeCausality: ""
        }
      }
    },
    PLP:{
      FILTER:{
        SHOW_HIDE_PANEL:"SHOW_HIDE_PANEL"
      }
    },
    GOOGLE: {
      FAST_ORDER: {
        GO_TO_PRODUCT: "GO_TO_PRODUCT",
        CHECK_AVAILABILITY: "CHECK_AVAILABILITY",
        BACK_IN_STOCK: "BACK_IN_STOCK",
        SIMILAR_PRODUCTS: "SIMILAR_PRODUCTS",
        ADD_TO_CART_FAST_ORDER: "ADD_TO_CART_FAST_ORDER"
      },
      ACCOUNT:{
        REPEAT_ORDER: "REPEAT_ORDER",
        REPEAT_ENTRY: "REPEAT_ENTRY",
      },
      PDP: {
        INIT: "INIT_PRODUCT",
        ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
        ADD_TO_CART_SUCCESS: "ADD_TO_CART_SUCCESS",
        ADD_TO_CART_ACCOUNT_SUCCESS: "ADD_TO_CART_ACCOUNT_SUCCESS",
        GO_TO_PRODUCT_FAST_ORDER: "GO_TO_PRODUCT",
        DOWNLOAD_HD_IMAGE: "DOWNLOAD_HD_IMAGE",
        DOWNLOAD_TECH_SHEET: "DOWNLOAD_TECH_SHEET",
        DOWNLOAD_INVOICE: "DOWNLOAD_INVOICE",
        DOWNLOAD_DDT: "DOWNLOAD_DDT",
        DOWNLOAD_DOCUMENT: "DOWNLOAD_DOCUMENT"
      },
      PLP: {
        INIT: "INIT_PLP",
        FROM_PLP_TO_PDP: "TO_PDP",
        TO_PLP: "TO_PLP"
      },
      CART: {
        REMOVE_QUANTITY: "REMOVE_QUANTITY",
        INCREASE_QUANTITY: "INCREASE_QUANTITY",
        MODIFIED_QUANTITY: "MODIFIED_QUANTITY",
        REMOVE: "REMOVE",
        MODIFIED_CAUSALITY: "MODIFIED_CAUSALITY",
        VIEW:"VIEW"
      },
      CHECKOUT: {
        STEP1: "DELIVERY_ADDRESS",
        STEP2: "DELIVERY_METHOD",
        STEP3: "PAYMENT_METHOD",
        STEP4: "SUMMARY_PAGE",
        STEP5: "PURCHASE",
        ONLY_ONE_STEP: "ONLY_ONE_STEP"
      },
      ORDER_CONFIRMATION: "ORDER_CONFIRMATION",
      LOG_IN: "LOG_IN",
      SELECT_AREA: "SELECT_AREA"
    },
    MODAL: {
      GENERIC: "MODAL_WARN",
      CLOSE: "MODAL_CLOSE",
      NEW_REFERENT: "NEW_REFERENT",
      COPY_SAMPLE: "COPY_SAMPLE",
    },
    LOADER: {
      SHOW: "LOADER_SHOW",
      HIDE: "LOADER_HIDE",
    }
  },
  HTTP: {
    RESPONSE: {
      OK: "OK",
      KO: "KO",
    }
  },
  DIVISION: {
    COMMERCIAL_ORGANIZATION: {
      FABRICS: ["00010-00030-00001", "00010-00030-00401", "00010-00030-00601", "00010-00030-00101", "10-USXF-US3"],
      YARNS: ["00021-00020-00001"],
      'flagLoropianaFabrics': {
        '00001': "00010",
        '00401': "00010",
        '00601': "00010",
        '00101': "00010",
        'US3': "10"
      },
      'flagSolbiatiFabrics': {
        '00001': "00010",
        '00401': "00010",
        '00601': "00010",
        '00101': "00010",
        'US3': "10"
      },
      'flagYarns': {'00001': "00021"},
      'flagShowRoom': {'00001': "00011"},
      'flagShowRoom4': {'00001': "00011"},
      'flagShowRoom5': {'00001': "00011"}
    },
    FLAGS: {
      SHOWROOM: ["flagShowRoom", "flagShowRoom4", "flagShowRoom5"],
      FLAGLOROPIANAFABRICS: "flagLoropianaFabrics",
      FLAGSOLBIATIFABRICS: "flagSolbiatiFabrics",
      FLAGSHOWROOM: "flagShowRoom",
      FLAGSHOWROOM4: "flagShowRoom4",
      FLAGSHOWROOM5: "flagShowRoom5",
      FLAGINTERIORS: "flagInteriors",
      FLAGYARNS: "flagYarns"
    },
    CODE:{
      YARNS:"00020"
    }
  },
  COLLECTION: {
    FABRICS: ["00031", "31"],
    SOLBIATI: ["00035", "35"],
    SHOWROOM: {
      '50' :'SS22',
      '51' :'FW22',
      '52' :'SS23'
    }


  },
  PRODUCT: {
    IMAGE: {
      FORMATS: {
        PRODUCT: 'product'
      }
    }
  },
  CLASSIFICATION: {
    '00030': {
      HEIGHT: 'altfinmin30',
      MIN_HEIGHT: 'altfinmin',
      WEIGHT: 'persfinmax30',
      MEASURE: 'mt',
    },
    'USXF': {
      HEIGHT: 'altfinmin30',
      MIN_HEIGHT: 'altfinmin',
      WEIGHT: 'persfinmax30',
      MEASURE: 'yd',
    },
    '00020': {
      HEIGHT: 'altfinmin20',
      MIN_HEIGHT: 'altfinmin',
      WEIGHT: 'persfinmax30',
      MEASURE: 'gr',
    },
  }
}



// WEBPACK FOOTER //
// ./src/utils/Constants.js